import { AgentRunDetail } from "@/components/agents/runs/agent-run-detail.tsx";
import { m } from "@/paraglide/messages.js";
import { agentRunQueryOptions } from "@/services/agent-runs-service.ts";
import { createEntityErrorBoundary } from "@/utils/entity-error-boundary.tsx";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { pageTitle } from "@/utils/page-title.ts";
import { RoutePending } from "@/components/custom/route-pending.tsx";

export const Route = createFileRoute(
	"/_authenticated/dashboard/agents/$agentId/runs/$runId",
)({
	loader: async ({ params, context: { queryClient } }) => {
		// Validate in the loader so a malformed id lands on the route's
		// errorComponent, not the global boundary (mirrors the agent route).
		z.uuid().parse(params.runId);
		await queryClient.ensureQueryData(
			agentRunQueryOptions(params.agentId, params.runId),
		);
	},
	errorComponent: createEntityErrorBoundary({
		title: m.agent_run_not_found_title,
		description: m.agent_run_not_found_description,
		backLabel: m.agent_run_not_found_back,
		backTo: "/dashboard/agents",
	}),
	component: RouteComponent,
	pendingComponent: RoutePending,
	head: () => ({
		meta: [{ title: pageTitle(m.agent_run_meta_title()) }],
	}),
});

function RouteComponent() {
	const { agentId, runId } = Route.useParams();
	// Keyed on the run: moving to another run (retry, the previous / retried-as
	// links) stays on this route, and the page's own state - the live steps, the
	// steps section's open state - belongs to the run it was built for.
	return <AgentRunDetail key={runId} agentId={agentId} runId={runId} />;
}
